export default "__VITE_ASSET__DuQ240r9__"